import React from "react";
import { motion } from "framer-motion";
import "../SubMenus/Mens.css";
import { Link } from "react-router-dom";
import pic1 from "../assets/mens1.jpg";
import pic2 from "../assets/mens2.jpg";
import pic3 from "../assets/mens3.jpg";
import pic4 from "../assets/mens4.jpg";
import pic5 from "../assets/lower-3.png";
import pic6 from "../assets/mens6.jpg";

const products = [
  {
    id: 1,
    title: "Men’s Jackets",
    subtitle: "Men’s Jackets",
    img:pic1 ,
    link:"/products/garments/men/jackets",
  },
  {
    id: 2,
    title: "Men’s Sweat Top & Hoodie",
    subtitle: "Men’s Sweat Top & Hoodie",
    img: pic2,
    link:"/products/garments/men/hoodies",
  },
  {
    id: 3,
    title: "Men’s Shirt",
    subtitle: "Men’s Shirt",
    img: pic3 ,
    link:"/products/garments/men/shirts",
  },
  {
    id: 4,
    title: "Men’s T-Shirt",
    subtitle: "Men’s T-Shirt",
    img: pic4 ,
    link:"/products/garments/men/tshirts",
  },
  {
    id: 5,
    title: "Men’s Short & Lower",
    subtitle: "Men’s Short & Lower",
    img: pic5 ,
    link:"/products/garments/men/shorts",
  },
  {
    id: 6,
    title: "Men’s Jeans & Pants",
    subtitle: "Men’s Jeans & Pants",
    img: pic6 ,
    link:"/products/garments/men/jeans",
  },
];

export default function MenProducts() {
  return (
    <>
   
   <div className="men-section">
      <h2 className="section-heading">Men’s Collection</h2>
      <div className="men-products">
        {products.map((product, index) => (
          <motion.div
            key={product.id}
            className="product-card"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            whileHover={{ scale: 1.05 }}
          >
             <Link to={product.link}>
            <img src={product.img} alt={product.title} className="product-img" />
            <p className="product-subtitle">{product.subtitle}</p>
            <h3 className="product-title">{product.title}</h3>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
    </>
  );
}
